import fetch from '../utils/fetch';
// import fetch from '../utils/fetch'
import { baseUrl } from '../utils/env';

/**
 * 获取微信openId
 */
export const ajaxWechatInfo = (data) => {
  return fetch(baseUrl + '/api/wechat/getWechatInfo', data, 'POST');
};
/**
 * 绑定
 */
export const ajaxWechatEmail = (data) => {
  return fetch(baseUrl + '/api/wechat/bindWechatEmail', data, 'POST');
};
/**
 * 解绑
 */
export const ajaxUnbindWechat = (data) => {
  return fetch(baseUrl + '/api/wechat/unBindWechatEmail', data, 'POST');
};
/**
 * 设备状态查询
 */
export const ajaxDeviceStatus = (data) => {
  return fetch(baseUrl + '/api/wechat/getDeviceStatus', data, 'POST');
};
// /**
//  * 获取图片验证码
//  */
// export const ajaxImageCode = () => {
//   return fetch(baseUrl + '/api/web/captcha/get/');
// };
